import { get_token } from "@/router";

import { client_domain } from "@/main.js";

export default {
  data() {
    return ({
      users: [],
      token_exists: false,
      visibleUsersCount: 4,
      showAllUsers: false,
      visible_domain: false,
    });
  },

  computed: {
    filtered_users() {
      return this.showAllUsers
        ? this.users
        : this.users.slice(0, this.visibleUsersCount);
    },
  },

  mounted() {
    this.token_exists = get_token();

    if(client_domain.includes('tdm')||client_domain.includes('chamber') || client_domain.includes('cbo') || client_domain.includes('demo') || 
      client_domain.includes('engagenet') || client_domain.includes('bosa')){
        this.visible_domain = true;
      }
  
    if (this.token_exists) {
      this.fetchUsers();
    }
  },

  methods: {
    getToken() {
      return get_token();
    },

    fetchUsers() {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_users/`,
          type: "GET",
          headers: {
            Authorization: `Token ${get_token()}`,
            "Content-Type": "application/json",
          },
          success: (response) => {
            if (
              response.status === "success" &&
              response.data &&
              response.data.users_list
            ) {
              this.users = response.data.users_list.map(user => ({
                ...user,
                // Add default values or transformations here if needed
              }));
            }
          },
          error: (error) => {
            console.error("Error fetching users:", error);
          },
        });
      },

      view_profile(user_id){
          window.location = `/profile?user_id=${user_id}`;

    }
  },
};
